<div class="modal-header">
  <div class="h5-text modal-title w-100" id="PgfAnnounceModal">Nicola Wealth Private Giving Foundation Portal</div>
  <button type="button" class="close" (click)="activeModal.dismiss('Cross click')" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <p>We are pleased to announce improved access and exciting new features on the Nicola Wealth Private Giving Foundation online client portal to view your personal charitable giving information. Access the NWPGF account by selecting the Fund profile in the top left dropdown to toggle between accounts.
  </p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">Close</button>
</div>